import { Box, useTheme } from '@mui/material';
import { keyframes } from '@emotion/react';
import { PumpWithoutPropeler } from 'src/assets/widgets/PumpWithoutPropeler';
import { Propeler } from 'src/assets/widgets/Propeler';

type Props = {
  isRunMode: boolean;
  isAlarmActive: boolean;
  width?: number;
  height?: number;
  propelerWidth?: number;
  showRotator: boolean;
  isMobile: boolean;
  isTriplexPump: boolean;
};

const rotate = keyframes`
0% { transform: translate(-50%, -50%) rotate(0deg); }
100% { transform: translate(-50%, -50%) rotate(360deg); }
`;

export const PropelerPumpIcon = ({
  isRunMode,
  isAlarmActive,
  width = 64,
  height = 85,
  propelerWidth = 30,
  showRotator,
  isMobile,
  isTriplexPump,
}: Props) => {
  const theme = useTheme();
  const primaryMainColor = theme.palette.primary.main;
  const greyColor = theme.palette.grey[400];
  const redColor = '#ff4842';
  const lighRedColor = '#ffdad9';

  let propelerColor = greyColor;
  let propelerTestId = 'offState';

  if (isAlarmActive) {
    propelerColor = redColor;
    propelerTestId = `activeAlarm-${isRunMode ? 'onState' : 'offState'}`;
  } else if (isRunMode && !isAlarmActive) {
    propelerColor = primaryMainColor;
    propelerTestId = 'onState';
  }

  return (
    <Box position="relative" width="fit-content" height="fit-content">
      <PumpWithoutPropeler
        width={width}
        height={height}
        fill={isAlarmActive ? lighRedColor : '#f4f4f7'}
      />
      <Box
        position="absolute"
        top={isMobile && isTriplexPump ? '60%' : '70%'}
        left="50%"
        data-sm={propelerTestId}
        sx={{
          width: propelerWidth,
          height: 30,
          transform: 'translate(-50%, -50%)',
          animation: isRunMode ? `${rotate} 1.5s linear infinite` : 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {showRotator && <Propeler width={propelerWidth} height={100} fill={propelerColor} />}
      </Box>
    </Box>
  );
};
